// extracted by mini-css-extract-plugin
module.exports = {"KPI":"KPI_KPI__wB_oc","Title":"KPI_Title__2TNZs","Body":"KPI_Body__1Z0u_","Value":"KPI_Value__352dx","Progress":"KPI_Progress__o7t57","Icon":"KPI_Icon__2uLO0"};